import styled from 'styled-components';

const CardGroup = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;

export { CardGroup };
